import React from "react";
import axios from "axios";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default class NewsLetterSubscribe extends React.Component {
  public state = {
    email: "",
    loading: false,
    success: false,
    error: false,
  };

  public handleInput = (e: any) => {
    this.setState({
      email: e.target.value,
    });
  };

  public submit = () => {
    if (this.state.email && !this.state.loading) {
      if (
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email)
      ) {
        this.setState({
          loading: true,
        });
        axios
          .post("/newsletter_subscribe", {
            email: this.state.email,
          })
          .then((response) => {
            const resp = response.data;
            if (resp.ok === true) {
              this.setState({
                loading: false,
                success: true,
                error: null,
                email: "",
              });
            } else {
              this.setState({
                loading: false,
                success: false,
                error: "There was an unexpected error",
              });
            }
          })
          .catch(() => {
            this.setState({
              loading: false,
              success: false,
              error: "There was an unexpected error",
            });
          });
      } else {
        this.setState({
          loading: false,
          success: false,
          error: "Please enter a valid email.",
        });
      }
    }
  };

  public render() {
    const { email, error, success, loading } = this.state;
    return (
      <div className="md:flex flex-col">
        <div className="subft__newsletter-subscribe__title">
          JOIN OUR NEWSLETTER
        </div>
        <div className="nl_form ns-form">
          <input
            type="email"
            name="email"
            onChange={this.handleInput}
            value={email}
            className="daisy-form-control w-full max-w-md"
            placeholder="Email address"
          />
          <button
            type="submit"
            onClick={this.submit}
            className="btn btn-inverse ml-2"
          >
            Subscribe
            {loading ? <i className="fa fa-spinner fa-pulse ml-1"></i> : null}
          </button>
        </div>
        {error ? (
          <div className="nl_error"> {error} </div>
        ) : success ? (
          <div className="nl_success"> Thank you for subscribing </div>
        ) : null}
      </div>
    );
  }
}
